export default "__VITE_ASSET__CZaCXcck__"